import { motion } from "framer-motion";
import { ArrowDownRight, Sparkles } from "lucide-react";
import { useLang } from "@/contexts/LanguageContext";

const Hero = () => {
  const { t } = useLang();

  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  const lines = [t.hero.tagWeBuild, t.hero.tagWeFix, t.hero.tagWeDeploy];

  return (
    <section
      id="top"
      className="relative min-h-screen pt-32 pb-16 px-6 md:px-10 overflow-hidden grain"
      data-testid="hero-section"
    >
      {/* Glow blobs */}
      <div className="glow-blob bg-[#ccff00]" style={{ top: "-100px", left: "-80px", width: 400, height: 400 }} />
      <div className="glow-blob bg-[#ff4500]" style={{ bottom: "-120px", right: "-80px", width: 460, height: 460, opacity: 0.35 }} />
      <div className="glow-blob bg-[#ff00cc]" style={{ top: "30%", right: "30%", width: 260, height: 260, opacity: 0.18 }} />

      <div className="relative z-10 max-w-[1500px] mx-auto">
        {/* <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.1, duration: 0.6 }}
          className="inline-flex items-center gap-2 pill pill-ghost !py-2 !px-4 text-xs uppercase tracking-widest"
          data-testid="hero-badge"
        >
          <Sparkles size={14} className="text-[#ccff00]" />
          {t.hero.pillBadge}
        </motion.div> */}

        <div className="mt-10 md:mt-16">
          {lines.map((line, i) => (
            <motion.h1
              key={line + i}
              initial={{ opacity: 0, y: 80 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.25 + i * 0.12, duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
              className="font-display uppercase text-[14vw] md:text-[10vw] lg:text-[9.5vw] leading-[0.88] block"
              data-testid={`hero-line-${i}`}
            >
              {i === 1 ? (
                <span className="text-[#ccff00]">{line}</span>
              ) : i === 2 ? (
                <span className="stroke-text">{line}</span>
              ) : (
                line
              )}
            </motion.h1>
          ))}
        </div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.85, duration: 0.6 }}
          className="mt-12 grid md:grid-cols-[1fr,auto] gap-8 items-end"
        >
          <p className="text-base md:text-lg text-white/70 max-w-2xl leading-relaxed balance">
            {t.hero.sub}
          </p>
          <div className="flex flex-wrap gap-3" data-testid="hero-ctas">
            <button
              onClick={() => scrollTo("services")}
              className="pill pill-primary"
              data-testid="hero-cta-primary"
            >
              {t.hero.ctaPrimary}
              <ArrowDownRight size={18} />
            </button>
            <a
              href="https://chat.whatsapp.com/EuutSTXjFvJ9dqnOryqazB"
              target="_blank"
              rel="noopener noreferrer"
              className="pill pill-ghost"
              data-testid="hero-cta-secondary"
            >
              {t.hero.ctaSecondary}
            </a>
          </div>
        </motion.div>
      </div>

      {/* Bottom marquee strip */}
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 1.1, duration: 0.6 }}
        className="absolute bottom-6 left-0 right-0 flex items-center justify-between px-6 md:px-10 text-xs uppercase tracking-[0.3em] text-white/40"
      >
        <span>{new Date().getFullYear()} ©</span>
        <span className="hidden md:block">Indonesia → Global</span>
        <span className="animate-pulse">Scroll ↓</span>
      </motion.div>
    </section>
  );
};

export default Hero;
